/*globals $*/
'use strict';

import lozad from 'lozad'
const getSvg = () => import("./external/functions/svg");
//const getOwlCarousel = () => import("./external/functions/owl_carousel");
const getHeaderFunctions = () => import("./external/functions/header");

var didScroll;
var lastScrollTop = 0;
var delta = 5;
var navbarHeight = 100; //$('header').outerHeight();

/* DETECT MOBILE */
var isMobile = false;
if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) 
    || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) { 
    isMobile = true;
}

$( document ).ready(function() {

    // LOAD NAVBAR IF NEEDED
    if($("#nav-open-close").length > 0) {
        getHeaderFunctions().then(headerModule => {
            headerModule.showNavBar();
        });
    }

    // LOAD SVG IF NEEDED
    if($(".svg").length > 0) {
        getSvg().then(svgModule => {
            svgModule.prepareSvg();
        });
    }


    // Activar animaciones de aparición de elementos
    
    $('.appear-up').each(function(){ calcularPosicion( $(this) ); });
    $('.appear-from-left').each(function(){ calcularPosicion( $(this) ); });
    $('.appear-from-right').each(function(){ calcularPosicion( $(this) ); });

    let space = 0;
    if (window.innerWidth < 800) {
        space = 40;
    }
    $('#button-start').on('click', function() {
       $('html, body').animate({
        scrollTop: $('#start').offset().top - space
        }, 1000);
    });

    // EQUIPO POPUP

    $('.popup__prev-button').click(function(){ 
        changePopUpStep(0, 'prev'); 
    });
    $('.popup__next-button').click(function(){ 
        changePopUpStep(0, 'next'); 
    });
    $('.popup__close-button').click(function(){ 
        $('#popup_people').removeClass('show'); 
    });
    $('.people-link').click(function(){ 
        var step = $(this).attr('data-step');
        $('#popup_people').addClass('show'); 
        changePopUpStep(step, 'fixed');
    });


    //DESPLEGABLES CARTA

    $('[id^="menu-button"]').on('click', function() {
        var id = $(this).data('id');
        if($(this).hasClass('selected')){
            closeAllDesplegables();
        } else {
            closeAllDesplegables();
            $(this).addClass('selected');
            $('#menu-content' + id).slideDown();
        }
    });

    // videos responsive
    iframeResize();

    //intervalo de tiempo para calcular constantemente posicion del scroll
    setInterval(function() {
        if (didScroll) {
            hasScrolled();
            didScroll = false;
        }
    }, 250);
    
});

$(window).scroll(function(){ 
    didScroll = true;

    var alto = $(window).height() - 100;
    var wScroll = $(window).scrollTop();

    $('.appear-up').each(function(){ calcularPosicion( $(this) ); });
    $('.appear-from-left').each(function(){ calcularPosicion( $(this) ); });
    $('.appear-from-right').each(function(){ calcularPosicion( $(this) ); });

});
$(window).resize(function(){ 
    // videos responsive
    iframeResize();
});


//Lazy load of all the images
document.addEventListener('DOMContentLoaded', function(){
    if($(".lozad").length > 0) {
        const observer = lozad('.lozad', {
          threshold: 0.1,
          load: function(el) {
            if(el.dataset.src){ el.src = el.dataset.src; }
            if(el.dataset.backgroundImage){ el.style.backgroundImage = "url('"+el.dataset.backgroundImage+"')"; }
          },
        });
        observer.observe();
    }
});

function hasScrolled() {
    var st = $(window).scrollTop();
    // Make sure they scroll more than delta
    /*if(Math.abs(lastScrollTop - st) <= delta)
        return;*/

    // If they scrolled down and are past the navbar, add class .nav-up.
    // This is necessary so you never see what is "behind" the navbar.
    /*if (st > lastScrollTop && st > navbarHeight){
        // Scroll Down
        //$('header').removeClass('nav-down').addClass('nav-up');
        $('.header').addClass('fixed');
    } else {
        // Scroll Up
        if(st + $(window).height() < $(document).height()) {
            //$('header').removeClass('nav-up').addClass('nav-down');
            $('.header').removeClass('fixed');
        }
    }*/

    if (st > navbarHeight){
        $('.header').addClass('fixed');
    } else {
        $('.header').removeClass('fixed');
    }
    if (st > ($('.slider').height() / 2)){
        $('#contact-buttons').addClass('show');
    } else {
        $('#contact-buttons').removeClass('show');
    }

    //lastScrollTop = st;
}

function calcularPosicion(element) {
    var alto = $(window).height() - 10;
    var wScroll = $(window).scrollTop();

    if(element.length && (element.offset().top - alto) < wScroll ){
        element.addClass('show');
        //element.removeClass('notshow');
    }
}

function iframeResize() {
    $('iframe').each(function () {
        var ratio = $(this).attr('height') / $(this).attr('width');
        var contentWidth = $(this).parent().width();
        $(this).attr('width', contentWidth).attr('height', contentWidth * ratio);
    });
}

function changePopUpStep( step, action ){
    var nextStep = 0;
    var actualStep = parseInt( $('#popup_people__actual-step').val() );
    var maxStep = parseInt( $('#popup_people__max-step').val() );

    var nextButton = $('#popup_people__next-button');
    var prevButton = $('#popup_people__prev-button');

    // Sumar o restar al step actual
    if( action == 'fixed' ){
        nextStep = step;
    }else{
        if( action == 'next' ){ nextStep = actualStep + 1; }
        if( action == 'prev' ){ nextStep = actualStep - 1; }

        if( nextStep > maxStep ){ nextStep = 1; }
        if( nextStep == 0 ){ nextStep = maxStep; }
    }

    $('#popup_people__actual-step').val( nextStep );

    // Amagar totes les taules
    $('#popup_people .people__popup-content').addClass('hide');
    // Mostrar la taula que toca
    $('#popup_people #popup_people__table--' + nextStep).removeClass('hide');
}

function closeAllDesplegables() {
    $('[id^="menu-content"]').slideUp();
    $('[id^="menu-button"]').removeClass('selected');
}

